import * as React from 'react';

import { Header } from '../../../components/NewbuildingTiledCarousel/FullscreenGallery/Header/Header';
import { NewbuildingTiledCarouselCallButton } from '../CallButton/NewbuildingTiledCarouselCallButton';
import { NewbuildingFavorite } from '../FavoriteButton';

export const HeaderContainer = ({ tabs }: { tabs: React.ReactNode }) => {
  return <Header favorite={<NewbuildingFavorite />} call={<NewbuildingTiledCarouselCallButton />} tabs={tabs} />;
};

HeaderContainer.displayName = 'HeaderContainer';
